export default "__VITE_ASSET__62bbdce8__"